/**
 * The two window sizes, derived rather than guessed.
 *
 * CALC.EXE lays its controls out in dialog units, and at 8pt MS Shell Dlg
 * those convert at 1.5px across and 1.625px down. Dialog 102 (Standard) is
 * 169 x 129du and dialog 101 (Scientific) is 316 x 164du, which is why the
 * window visibly grows when you switch views — the real one did the same.
 *
 * `Calculator.module.css` works in the same units, so if one of these numbers
 * moves the other has to move with it.
 */

/** Pixels per dialog unit, horizontally and vertically. */
export const DU_X = 1.5;
export const DU_Y = 1.625;

/** Padding either side of the keypad, plus the window's own 3px Luna frame. */
const CHROME_W = 12 + 12;

/** A key and the gutter under it: 18du and 2du. */
const ROW = Math.round(18 * DU_Y);
const GUTTER = 3;
const rows = (n: number) => n * ROW + (n - 1) * GUTTER;

/**
 * The keypad's own height. Standard is five rows — the clearing row and four
 * of keys. Scientific is the two rows of radios and lamps, then five of keys.
 */
const STANDARD_PAD = rows(5);
const SCIENTIFIC_PAD = 32 + 6 + 36 + 6 + rows(5);

/**
 * Everything the keypad is not: the title bar, the menu bar, the readout and
 * its margins, and the frame. Measured once against the Standard view, whose
 * height was tuned to give its keys the 29px the dialog units call for.
 */
const CHROME_H = 250 - STANDARD_PAD;

const width = (du: number) => Math.round(du * DU_X + CHROME_W);

export const STANDARD_SIZE = { w: width(159), h: CHROME_H + STANDARD_PAD };
export const SCIENTIFIC_SIZE = { w: width(305), h: CHROME_H + SCIENTIFIC_PAD };
